import { useQuery } from "@tanstack/react-query";

// https://developers.google.com/maps/documentation/places/web-service/place-autocomplete
const URL = "https://places.googleapis.com/v1/places:autocomplete";

interface AutocompleteRequest {
  input: string;
}

export type PlacePrediction = {
  place: string;
  placeId: string;
  structuredFormat: {
    mainText: {
      matches: { endOffset: number }[];
      text: string;
    };
    secondaryText: {
      text: string;
    };
  };
  text: {
    matches: { endOffset: number }[];
    text: string;
  };
  types: string[];
};

type AutocompleteResponse = {
  suggestions: {
    placePrediction: PlacePrediction;
  }[];
};

export const usePostGooglePlacesAutocomplete = (
  request: AutocompleteRequest
) => {
  return useQuery<AutocompleteResponse>({
    queryKey: ["googlePlacesAutocomplete", request.input],
    queryFn: async () => {
      const response = await fetch(URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Goog-Api-Key": process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
        },
        body: JSON.stringify(request),
      });

      if (!response.ok) {
        let errorMessage = `Error fetching place predictions: ${response.status} ${response.statusText}`;
        try {
          const errorData = await response.json();
          if (errorData && errorData.error && errorData.error.message) {
            errorMessage = `Error fetching place predictions: ${errorData.error.message}`;
          }
        } catch {
          // Ignore JSON parse errors, use default errorMessage
        }
        throw new Error(errorMessage);
      }

      return response.json();
    },
    enabled: !!request.input,
  });
};
